<template>
  <div class="min-height-dt" v-if="!isOnSearchPage">
    <div
      :dependentComputedProps="{
        getSeparateVariants,
      }"
    ></div>
    <div
      v-for="(item, index) in productCategories"
      :key="index"
      class="cards-wrap clearfix options-api"
      :style="{}"
    >
      <div
        v-if="shouldShowAllProductCategories || index < 1"
        :class="
          Object.keys(getOneCategoryProductItems(item?.nodeId) || {})?.length >
          0
            ? 'mb30 dt-mb48'
            : ''
        "
      >
        <p :id="'element_catg_' + item?.nodeId"></p>
        <div class="d-flex justify-content-between align-items-center">
          <h3
            class="card-catg-name"
            :class="{
              subCategory: !item?.isParentCategory,
            }"
            v-if="
              Object.keys(getOneCategoryProductItems(item?.nodeId) || {})
                ?.length > 0 || isThisCategoryParentCategory(item?.nodeId)
            "
          >
            {{ item?.nodeName?.split("_").join(" ") }}
            <span
              v-if="
                Object.keys(getOneCategoryProductItems(item?.nodeId) || {})
                  ?.length > 0
              "
              >({{
                Object.keys(getOneCategoryProductItems(item?.nodeId)).length
              }})</span
            >
          </h3>
          <span
            v-if="
              clientPlatform == 'Web' &&
              !item?.isParentCategory &&
              Object.keys(getOneCategoryProductItems(item?.nodeId) || {})
                ?.length == 3
            "
            class="view-all-cta"
            @click="redirectToMenuPage(item)"
            >View All</span
          >
        </div>

        <div class="cards-holder">
          <hongs-product-card
            v-for="(value, key, subIndex) in getOneCategoryProductItems(
              item?.nodeId
            )"
            :key="key"
            :data-item="value"
            :data-item-index="subIndex"
            :data-cardRounded="productCardProps.cardRounded"
            :data-smallCards="productCardProps.smallCards"
            :data-hideImage="productCardProps.hideImage"
            :showFullInfo="true"
            :data-counterText="item?.nodeId"
            :data-categoryId="item?.nodeId"
          ></hongs-product-card>
        </div>
      </div>
    </div>
    <!-- item add/remove toast msg -->
    <toast-msg
      v-if="showItemToastMsg"
      :data-img="staticImgBaseUrl + '/images/global/itemToastIcon.svg'"
      :data-text="itemToastMsg"
      :data-style="'item-toast-msg'"
      :data-text-color="'textWhite'"
    ></toast-msg>
  </div>
</template>

<script>
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../helpers/storeKeys";
import HongsProductCard from "./HongsProductCard.vue";
import { clientPlatform } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl, showItemToast } from "../config/apiEndpoints";
import { defineAsyncComponent } from "vue";

export default {
  name: "VerticalProductScroll",
  components: {
    HongsProductCard,
    ToastMsg: defineAsyncComponent(() => import("./ToastMsg.vue")),
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      productCardProps: {
        cardRounded: true,
        smallCards: false,
        hideImage: false,
      },
      defaultFilter: "ALL",
      staticImgBaseUrl,
      parsedResults: [],
      clientPlatform,
    };
  },
  mounted() {
    this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
    this.processResultDataForStore(this.parsedResults);
    if (LocalStorageFunc.isLoggedIn()) {
      this.$store.dispatch(keyMapsAction.GET_FAVOURITE_IDS_API, {});
    } else {
      this.$store.commit(
        keyMapsMutation.MARK_FAVOURITE_IDS,
        LocalStorageFunc.getFavouriteIds()
      );
    }
    window.addEventListener("DOMContentLoaded", () => {
      if (window.innerHeight + 5 < document.documentElement.scrollHeight) {
        window.addEventListener("scroll", () => {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOULD_SHOW_ALL_PRODUCT_CATEGORIES,
            true
          );
        });
      } else {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOULD_SHOW_ALL_PRODUCT_CATEGORIES,
          true
        );
      }
    });
    this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false);
  },
  updated() {
    //console.warn("updated product category : ", this.categoryId);
  },
  methods: {
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, data);
      this.$store.commit(
        keyMapsMutation.UPDATE_IMG_BASE_URL,
        data?.mediaBaseURL
      );
    },
    redirectToMenuPage(category) {
      const id = category?.isSubCategory
        ? this.getCategoryId(category)
        : category?.metadataMap?.categoryId?.values[0];
      Utility.sendToMenuScreen(id);
    },
    getCategoryId(category) {
      return this.productCategories.find(
        (x) => category.parentNodeId === x.nodeId
      )?.metadataMap?.categoryId?.values[0];
    },
  },
  computed: {
    getSeparateVariants() {
      let allProducts = {};
      let productCategoryMap =
        this.$store.state.ProductItems.productCategoryMap;
      Object.keys(productCategoryMap)?.map((productId) => {
        allProducts = {
          ...allProducts,
          ...this.$store.getters[keyMapsGetter.GET_SEPARATE_VARIANTS](
            productId
          ),
        };
      });
      this.$store.commit(
        keyMapsMutation.UPDATE_CART_ITEMS_LISTING_PAGE_ITERATOR,
        allProducts
      );
      return allProducts;
    },
    getOneCategoryProductItems() {
      return (categoryId) => {
        const oneCategoryProductItems =
          this.$store.getters[keyMapsGetter.GET_PRODUCTS][categoryId];

        const products = this.$store.state.ProductItems.productCategory.find(
          (x) => x.nodeId === categoryId
        )?.children;

        if (!products) return [];
        const filteredProducts = products
          .map((product) => oneCategoryProductItems[product?.skuId])
          .filter(Boolean);

        if (clientPlatform === "Web" && filteredProducts) {
          const keys = Object.keys(filteredProducts);
          if (keys.length > 3) {
            const slicedProducts = {};
            keys.slice(0, 3).forEach((key) => {
              slicedProducts[key] = filteredProducts[key];
            });
            return slicedProducts;
          }
        }
        return filteredProducts;
      };
    },
    productCategories() {
      let pCategories = this.$store.state.ProductItems.productCategory;

      if (!pCategories?.length) {
        let pMapShort = this.$store.state.ProductItems.productCategoryMapShort;
        return Object.keys(pMapShort).map((key) => {
          return { nodeId: key, nodeName: pMapShort[key] };
        });
      }
      return pCategories;
    },
    shouldShowAllProductCategories() {
      return this.$store.state.ProductItems.shouldShowAllProductCategories;
    },
    isThisCategoryParentCategory() {
      return (categoryId) => {
        let flts = this.$store.getters[keyMapsGetter.GET_APPLIED_FILTERS];
        if (!flts.includes(this.defaultFilter)) {
          return false;
        }
        let pCategories = this.$store.state.ProductItems.productCategory;
        let pC = pCategories.find((item) => item.nodeId == categoryId);
        return pC?.isParentCategory;
      };
    },
    itemToastMsg() {
      return this.$store.state.Cart.itemToastMsg;
    },
    showItemToastMsg() {
      return this.$store.state.Cart.showItemToastMsg && showItemToast;
    },
    isOnSearchPage() {
      return Utility.isCurrentlyAtUrl("/search");
    },
  },
};
</script>
